import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/emissions`;

export const emissionService = {
  // Get all emissions
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.e_ledger_id) params.append('e_ledger_id', filters.e_ledger_id);
    if (filters.emission_scope) params.append('emission_scope', filters.emission_scope);
    const response = await axios.get(`${API_BASE}?${params}`);
    return response.data;
  },

  // Get emission by ID
  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  // Record new emission
  record: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  // Get emissions by ledger
  getByLedger: async (ledgerId) => {
    const response = await axios.get(`${API_BASE}/by-ledger/${ledgerId}`);
    return response.data;
  }
};

export default emissionService;
